import { c as _c } from "react/compiler-runtime";
import { createContext, ReactNode } from 'react';
import { useRouteUrlHistory } from './useRouteUrlHistory';
interface Context {
  previousRoute: string;
}
export const HistoryContext = createContext<Context>({
  previousRoute: ''
});
export function HistoryProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    previousRoute
  } = useRouteUrlHistory();
  let t1;
  if ($[0] !== previousRoute) {
    t1 = {
      previousRoute
    };
    $[0] = previousRoute;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <HistoryContext.Provider value={t1}>{children}</HistoryContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}